<template>
  <div>
    <div :id="myChartId" :style="{height: '350px'}"></div>
  </div>
</template>

<script>
  export default {
    name: "EberLine",
    props: {
      xAxis: {
        type: Array,
        default () {
          return [];
        }
      },
      series: {
        type: Array,
        default () {
          return [];
        }
      },
      legend: {
        type: Array,
        default () {
          return [];
        }
      }
    },
    data () {
      return {
        myChartId: Math.round(Math.random() * 10000),
        myChart: null,
        mySeries: null,
        myXAxis: null,
        options: {
          tooltip: {
            trigger: 'axis'
          },
          color: ['#61A5E8', '#7ECF51'],
          legend: {
            data: [],
              bottom: 'bottom',
              icon: 'circle',
          },
          grid: {
            left: '3%',
              right: '4%',
              bottom: '8%',
              containLabel: true
          },
          xAxis: {
            type: 'category',
              boundaryGap: false,
              data: []
          },
          yAxis: {
            type: 'value'
          },
          series: []
        }
      }
    },
    mounted(){
      let _self = this;
      _self.drawLine();
      window.addEventListener('resize', function () {
        _self.myChart.resize()
      })
    },
    watch:{
      series(){
        this.changeLine();
      }
    },
    beforeDestroy() {
      let _self = this;
      window.removeEventListener('resize', function () {
        _self.myChart.resize()
      })
    },
    methods: {
      drawLine() {
        var _self = this;
        _self.myChart = _self.$echarts.init(document.getElementById(this.myChartId));
        _self.myChart.setOption(this.options);
        _self.myChart.setOption({
          legend: {
            data: this.legend
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _self.xAxis
          },
          series: _self.series
        });
      },
      changeLine(){
        // console.log('changeLine', this.xAxis);
        // const _series = [];
        var _self = this;
        _self.myChart.clear();
        _self.myChart.setOption(this.options);
        _self.myChart.setOption({
          legend: {
            data: _self.legend
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _self.xAxis
          },
          series: _self.series
        });
      }
    }
  }
</script>

<style scoped>
</style>
